<template>
  <v-container v-if="is_self_route">
    <v-card class="rounded-t-lg">
      <v-card-title class="title style-color-main-gray">
        <span>Список категорий</span>
        <v-spacer></v-spacer>

        <v-btn @click="openCreateDialog" color="secondary" text>
          <v-icon>add</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
                @click="reloadData()"
                class="mr-2"
                medium
                v-on="on"
            >
              update
            </v-icon>
          </template>
          <span>Обновить данные</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="getItems"
          :loading="isLoading"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.size"
          :server-items-length="getCount"
          :footer-props="{'items-per-page-options':[25,50,100]}"
          no-data-text="Данные отсутствуют"
          no-results-text="Ничего не было найдено"
          :expanded.sync="expanded"
          show-expand
          single-expand
      >
        <template v-slot:item.date_opened="{item}">
          {{ displayDate(item.date_opened, true) }}
        </template>
        <template v-slot:item.date_closed="{item}">
          {{ displayDate(item.date_closed, true) }}
        </template>
        <template v-slot:item.start_date="{item}">
          {{ displayDate(item.start_date) }}
        </template>
        <template v-slot:item.end_date="{item}">
          {{ displayDate(item.end_date) }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-row>
              <v-col cols="12">
                <DatesList :event="item.id"></DatesList>
              </v-col>
            </v-row>
          </td>
        </template>
        <template v-slot:item.btn="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  @click="openEditDialog(item)"
                  class="mr-2"
                  medium
                  v-on="on"
              >
                edit
              </v-icon>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  @click="openDeleteDialog(item)"
                  medium
                  v-on="on"
              >
                delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-card-text>Данные не загружены</v-card-text>
        </template>
      </v-data-table>
    </v-card>
    <EditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :docs_data="docs_data"
        @close="closeEditDialog"
    ></EditDialog>
    <checkDelete
        v-if="dialog_delete"
        :opened="dialog_delete"
        :docs_data="docs_data"
        @close="closeDeleteDialog"
    ></checkDelete>
  </v-container>
  <router-view v-else></router-view>
</template>


<script>
import UserDataMixin from '@/mixins/UserDataMixin'
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import DatesList from "@/modules/recording/page/admin/events/dates/DatesList"
import names from "@/modules/recording/routers/names";
import {displayDate} from "@/helper";
import EditDialog from "@/modules/recording/page/admin/events/components/EditDialog.vue";
import checkDelete from "@/modules/recording/page/admin/events/components/checkDelete.vue";
import {mapActions, mapGetters} from "vuex";


export default {
  name: "List",
  mixins: [
    PaginatedDataMapperMixin,
  ],

  components: {
    checkDelete,
    EditDialog,
    DatesList
  },
  computed: {
    is_self_route: function () {
      return this.$route.name === names.ADMIN.EVENTS
    },
    ...mapGetters({
      getItems: 'events/getEvents',
      getCount: 'events/getEventsCount',
      isLoading: 'events/isLoadingEvents'
    }),
  },
  data() {
    return {
      pagination: {},
      dialog_add_edit: false,
      dialog_delete: false,
      edit_status: undefined,
      docs_data: undefined,
      expanded: [],
      selectors: {
        parentCategory: [],
      },
      loading: true,
      headers: [
        {text: 'Название', sortable: false, align: 'left', value: "name",},
        {text: 'Дата открытия', sortable: false, align: 'left', value: "date_opened",},
        {text: 'Дата закрытия', sortable: false, align: 'left', value: "date_closed",},
        {text: 'Дата начала', sortable: false, align: 'left', value: "start_date",},
        {text: 'Дата окончания', sortable: false, align: 'left', value: "end_date",},
        {text: 'Описание', sortable: false, align: 'left', value: "description",},
        {text: 'Действия', sortable: false, align: 'right', value: "btn",},
        {text: '', value: 'data-table-expand'},
      ]
    }
  },

  methods: {
    ...mapActions({
      loadList: 'events/loadEventsList',
      deleteRole: 'events/deleteEvents',
    }),
    displayDate,
    openCreateDialog() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.docs_data = undefined
    },
    openEditDialog(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.docs_data = item
    },
    openDeleteDialog(item) {
      this.dialog_delete = true
      this.docs_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.dialog_delete = false
      this.docs_data = undefined
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteRole({
          id: this.docs_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      }
      this.dialog_delete = false
      this.docs_data = undefined
    },
    loadData(url = undefined) {
      this.loadList({
        url: url,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
        }
      })
    },
    reloadData() {
      this.loadData()
    },

  },
  created() {
    this.loadData()
  }
}
</script>
<style scoped>
</style>
